export const SuccessIcon = () => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.5 0C19.1274 8.69081e-07 24.5 5.37259 24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.499999 18.6274 0.5 12C0.500001 5.37258 5.87258 8.64023e-07 12.5 0ZM12.5 1.8457C6.89219 1.8457 2.3457 6.39219 2.3457 12C2.3457 17.6078 6.89219 22.1543 12.5 22.1543C18.1078 22.1543 22.6543 17.6078 22.6543 12C22.6543 6.39219 18.1078 1.8457 12.5 1.8457ZM15.6406 9.48242C15.9731 9.15211 16.5181 9.14705 16.8574 9.4707C17.1965 9.79438 17.2024 10.325 16.8701 10.6553L12.0527 15.4414C11.8841 15.6088 11.6611 15.6924 11.4375 15.6924C11.2262 15.6924 11.0145 15.6173 10.8486 15.4658L8.15723 13.0098C7.81037 12.6935 7.7925 12.163 8.11719 11.8252C8.44208 11.4874 8.98706 11.4708 9.33398 11.7871L11.4121 13.6836L15.6406 9.48242Z"
                fill="#00AC31"
            />
        </svg>
    );
};
